import React, { useState, useEffect } from "react";
import AddDataBody from "../components/AddData/AddDataBody";
import AddDataTitle from "../components/AddData/AddDataTitle";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import apiClient from "../libraries/ApiClient";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-height: calc(100% - 50px);
`;

function ReferralAddData({ lineUserId }) {
  const navigate = useNavigate();
  const [sendData, setSendData] = useState(null);
  const [sendMediaData, setSendMediaData] = useState(null);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);
  return (
    <Container>
      <AddDataTitle sendData={sendData} sendMediaData={sendMediaData} />
      <AddDataBody
        setSendData={setSendData}
        setSendMediaData={setSendMediaData}
      />
    </Container>
  );
}

export default ReferralAddData;
